/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import notification from '../config/notifications.config.json';
import axios from 'axios';
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { CREATE_SUPPLIER } from '../graphql';
import { VApplication } from '@/application';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { UploadDocService } from '@/services/uploadService';
import { camelCase } from 'change-case';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

const uploadSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.UploadDocService') as UploadDocService;
};

export interface ICreateSupplierMethods extends IPluginMethodMap {
  createSupplier(args: any): Promise<any>;
}

export interface ICreateSupplierMethodsProps {
  name: string;
  description?: string;
  logo?: any;
  email: string;
  userName: string;
  userEmail: string;
  orgType: string;
}

export class CreateSupplierService implements IAgentPlugin {
  readonly methods: ICreateSupplierMethods;

  constructor() {
    this.methods = {
      createSupplier: this.createSupplier.bind(this),
    };
  }

  async createSupplier(args: ICreateSupplierMethodsProps) {
    const storageService = StorageModule?.getInstance();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    console.log(`args inside service`, client, args);
    const orgDetails = storageService?.get('myProfile', 'local')?.orgData;
    const orgId = orgDetails?.id;
    let icon: any;
    if (args?.logo) {
      icon = await uploadSrv()?.uploadDoc(args?.logo?.base64);
    }
    try {
      if (client && orgId) {
        const res = await client.mutate({
          mutation: CREATE_SUPPLIER,
          variables: {
            input: [
              {
                name: args?.name,
                email: args?.email,
                description: args?.description,
                logo: icon?.url,
                orgType: args?.orgType ? camelCase(args?.orgType) : '',
                users: {
                  create: [
                    {
                      node: {
                        name: args?.userName,
                        email: args?.userEmail,
                      },
                    },
                  ],
                },
                parentOrg: {
                  connect: {
                    where: {
                      node: {
                        id: orgId,
                      },
                    },
                    edge: {
                      orgType: args?.orgType ? camelCase(args?.orgType) : '',
                    },
                  },
                },
              },
            ],
          },
          fetchPolicy: 'no-cache',
        });
        if (res?.data) {
          return {
            ...res?.data?.createOrgs,
            notification: notification?.createSupplierSuccess,
          };
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
